module.exports = __webpack_public_path__ + "static/media/Financial_Product_Terms_-_VFSC.1cbcaefa.pdf";